import { Link } from "react-router-dom";
import { Sparkle, UserCircle, UsersThree } from "@phosphor-icons/react";

// Quick links to the guided showcase pages. Place near the top of public pages.
export default function SampleLinks({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="sample-links">
      <span className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground"><Sparkle size={13} weight="fill" className="text-secondary" /> Take a look:</span>
      <Link to="/sample-alumni" data-testid="sample-alumni-link"
        className="inline-flex items-center gap-1.5 rounded-full border border-secondary/30 bg-secondary/5 px-3 py-1.5 text-xs font-medium text-secondary transition-colors hover:bg-secondary/10">
        <UserCircle size={15} weight="duotone" /> Sample Alumni Profile
      </Link>
      <Link to="/sample-institution" data-testid="sample-institution-link"
        className="inline-flex items-center gap-1.5 rounded-full border border-secondary/30 bg-secondary/5 px-3 py-1.5 text-xs font-medium text-secondary transition-colors hover:bg-secondary/10">
        <UsersThree size={15} weight="duotone" /> Sample Institution Alumni Group
      </Link>
    </div>
  );
}
